module.exports = __webpack_public_path__ + "img/600-324b53.png";